/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

import ResourceApi from '../../Api/SiteApi/ResourceApi';
import Loader from '../loader/Loader';

import { runApp } from './animation3d';
import { ModelViewer } from './lib/ModelViewer';
import { loadAssetsByMachine, loadModelByMachine } from './services/loadAssets';
import mapLotterySlugToMachine from './services/mapLotterySlugToMachine';

import DivButton from 'components/common/DivButton';

type Props = {
    readonly results: {
        readonly transparency_numbers: number[][];
    };
    readonly lotterySlug: string;
};

function DrawAnimation({ results, lotterySlug }: Props) {
    const [isPlay, setIsPlay] = useState(false);
    const [playButtonImage, setPlayButtonImage] = useState(null);
    const [buttonImage, setButtonImage] = useState(null);

    useEffect(() => {
        if (!isPlay) {
            ResourceApi.getImageByTemplate(
                `draw-animation/textures/${lotterySlug}_play_button.jpg`,
                'draw-animation/textures/play_button.jpg'
            ).then((response) => {
                setPlayButtonImage(response);
            });
            ResourceApi.getImageByTemplate(
                `draw-animation/textures/${lotterySlug}_button.png`,
                'draw-animation/textures/button.png'
            ).then((response) => {
                setButtonImage(response);
            });
            return;
        }

        const result = results.transparency_numbers.reduce((accumulator, value) => accumulator.concat(value), []);
        const machine = mapLotterySlugToMachine(lotterySlug);

        if (machine === null) {
            return;
        }

        ResourceApi.getImageByTemplate(
            `draw-animation/textures/${lotterySlug}_intro.jpg`,
            'draw-animation/textures/intro.jpg'
        ).then((response) => {
            runApp(
                (viewer: ModelViewer) => {
                    loadAssetsByMachine(machine, viewer, result);
                },
                (viewer) => {
                    loadModelByMachine(machine, viewer);
                },
                () => {
                    document.getElementById('app-3d-play').remove();
                },
                lotterySlug,
                response
            );
        });
    }, [isPlay]);

    return (
        <div className="d-flex align-center align-content-center col-12 my-3">
            <div id="app-3d-container">
                <DivButton id="app-3d-play" onClick={() => setIsPlay(true)}>
                    <Loader
                        isLoading={playButtonImage === null}
                        elementToShow={<img src={playButtonImage} alt="play" className="w-100" />}
                        additionalStyles="w-100"
                    />
                    <Loader
                        isLoading={buttonImage === null}
                        elementToShow={<img id="app-3d-button" src={buttonImage} alt="button" />}
                    />
                </DivButton>
                <div id="app-3d-loader">
                    <span />
                </div>
                <canvas id="app-3d-canvas" />
                <div id="app-3d-output" />
            </div>
        </div>
    );
}

export default DrawAnimation;
